import React from "react"

const SiteContext = React.createContext(null)

export default SiteContext
